import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/apiClient";
import { useAuthStore } from "@/store/authStore";
import type { Admin } from "@/types/admin";

export function useCurrentUser() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return useQuery<Admin>({
    queryKey: ["auth", "me"],
    queryFn: () => apiClient.get<Admin>("/auth/me"),
    enabled: isAuthenticated,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
